import { Fragment, useContext, useState } from "react";
import { FiltersProvider } from "../../../components/providers/FiltersProvider";
import { menuRoutes } from "../../../router/menu";
import PageHeader from "../../../layout/shared/page-header";
import { PrivilegeContext } from "../../../components/priviledge/PriviledgeProvider";
import { Button } from "rizzui";
import cn from "../../../utils/classNames";
import { Product } from "../../../type/entities/product-type";
import ProductList from "./ProductList";

const ProductsListWrapper = () => {

    // STATES

    const [isOpenFormDrawer, setIsOpenFormDrawer] = useState(false);
    const [productSelected, setProductSelected] = useState<Product | null>(null);

    const breadCrumb = [
        { name: 'Administración' },
        { name: 'Gestión de productos' },
        { name: 'Productos', href: menuRoutes.products.path },  
    ];

    const defaultFilters = {};

    // HOOKS

    const { userCan } = useContext(PrivilegeContext);

    // RENDER

    return (
        <Fragment>
            <FiltersProvider defaultFilterFilters={defaultFilters} >
                <PageHeader title="Listado de productos" breadcrumb={breadCrumb}>
                    {
                        userCan('create', 'product') &&
                        (
                            <Button
                                color="primary"
                                onClick={() => { 
                                    setIsOpenFormDrawer(true) 
                                    setProductSelected(null)
                                }}
                                className={cn(['mt-4 md:mt-0'])}
                            >
                                Crear producto
                            </Button>
                        )
                    }
                </PageHeader>
                <ProductList openFormDrawer={isOpenFormDrawer} setOpenFormDrawer={setIsOpenFormDrawer} productSelected={productSelected} setProductSelected={setProductSelected} />
            </FiltersProvider>
        </Fragment>
    );
};

export default ProductsListWrapper;